import { api } from '@setplex/tria-api'
import { attach, sample } from 'effector'
import { createForm } from 'effector-forms'
import { model as countryModel } from '~/entities/country'
import { minLength } from '~/shared/validators'

// sign up request effect
export const signUpByPhoneFx = attach({
  effect: api.subscriber.signUpByPhoneFx,
})

// sign up form
export const signUpByPhoneForm = createForm({
  fields: {
    phoneNumber: {
      init: '+' as string,
      rules: [minLength.validator(2)],
    },
  },
  validateOn: ['submit'],
})

// automatically set initial country code
sample({
  clock: countryModel.$phoneNumberCountyCode,
  fn: (code) => ({ phoneNumber: `+${code}` }),
  target: signUpByPhoneForm.setInitialForm,
})

// automatically reset initial value if the field is empty
sample({
  clock: signUpByPhoneForm.fields.phoneNumber.$value,
  filter: (phone) => phone === '',
  target: signUpByPhoneForm.fields.phoneNumber.reset,
})

// send sign-up request
sample({
  clock: signUpByPhoneForm.formValidated,
  target: signUpByPhoneFx,
})
